import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: 'solid 1px lightgrey',
    height: 66,
    padding: '0 12px',

    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  search: {
    flexBasis: '220px',
    maxWidth: '220px',
    height: '36px'
  },

  button: {
    width: '36px',
    height: '36px'
  }
}))

export default useStyles
